<template>
  <div class="sm-stock-lots-detail">
    <DxDataGrid
      :data-source="items"
      :show-column-lines="true"
      :show-row-lines="false"
      :show-borders="true"
      :column-auto-width="true"
      :row-alternation-enabled="true"
      :no-data-text="$t('common.no_data_text')"
      :load-panel="{ enabled: true }"
    >
      <DxColumn data-field="lot" :caption="$t('lot_items.lot')" :min-width="140" />
      <DxColumn
        data-field="expiration_date"
        :caption="$t('common.expiration_date')"
        data-type="date"
        :format="dateFormat"
        :min-width="140"
      />
      <DxColumn
        data-field="available_quantity"
        :caption="$t('lot_items.available_qty')"
        data-type="number"
        :min-width="140"
      />
      <DxColumn
        data-field="measure_unit"
        :caption="$t('common.measure_unit')"
        :allow-sorting="false"
        :allow-filtering="false"
        :min-width="90"
      />
      <DxPaging :enabled="false" />
    </DxDataGrid>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { DxDataGrid, DxColumn, DxPaging } from "devextreme-vue/data-grid";
import { mapAvailableLotGroups } from "~/helpers/stockHelper";

export default {
  name: "StockLotsMasterDetail",
  props: {
    rowData: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      items: [],
    };
  },
  components: {
    DxDataGrid,
    DxColumn,
    DxPaging,
  },
  computed: {
    ...mapGetters({
      getDxGridDefaultDateFormat: "settings/getDxGridDefaultDateFormat",
    }),
    dateFormat() {
      return this.getDxGridDefaultDateFormat || "yyyy-MM-dd";
    },
    productUuid() {
      return this.rowData?.product?.uuid || this.rowData?.product_uuid || "";
    },
    warehouseUuid() {
      return this.rowData?.warehouse_uuid || this.rowData?.warehouse?.uuid || "";
    },
    measureUnitSymbol() {
      return this.rowData?.product?.measure_unit?.symbol || this.rowData?.measure_unit?.symbol || "";
    },
  },
  watch: {
    rowData: {
      handler() {
        this.fetchLots();
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    ...mapActions({
      getSmStockMovementItemsAvailableSum: "smStocks/getSmStockMovementItemsAvailableSum",
    }),
    async fetchLots() {
      if (!this.productUuid || !this.warehouseUuid) {
        this.items = [];
        return;
      }
      const payload = {
        product_uuid: this.productUuid,
        warehouse_uuid: this.warehouseUuid,
        enablePagination: 0,
        limit: 99999,
      };
      const response = await this.getSmStockMovementItemsAvailableSum(payload);
      const data = response?.data?.data || response?.data || [];
      this.items = mapAvailableLotGroups(data).map((group) => ({
        ...group,
        measure_unit: this.measureUnitSymbol || "-",
      }));
    },
  },
};
</script>

<style scoped>
.sm-stock-lots-detail {
  padding: 12px 16px 16px;
}

::v-deep .no-lot-detail .dx-command-expand .dx-icon {
  visibility: hidden;
}
</style>
